<form [formGroup]="form" *ngIf="form">
  <div class="column-2">
    <div class="col">
      <div
        class="input-container"
        *digitalPlatformPermission="'update:generator:parent_customer'"
      >
        <label> Parent Customer Name </label>
        <mat-form-field appearance="outline">
          <input
            maxlength="64"
            matInput
            formControlName="parentCustomerName"
            [tabIndex]="1"
          />
          <mat-error *ngIf="errorHandling('parentCustomerName', 'required')">
            Parent Customer Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label> Generator Name </label>
        <mat-form-field
          appearance="outline"
          [ngClass]="generatorFieldsDisabled ? 'mat-form-field-readonly' : ''"
        >
          <input
            maxlength="64"
            matInput
            formControlName="name"
            [tabIndex]="3"
            [readonly]="generatorFieldsDisabled"
          />
          <mat-error *ngIf="errorHandling('name', 'required')">
            Generator Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div
      class="col"
      *digitalPlatformPermission="'update:generator:parent_customer'"
    >
      <div class="input-container">
        <label> Customer Name </label>
        <mat-form-field appearance="outline">
          <input
            maxlength="64"
            matInput
            formControlName="customerName"
            [matAutocomplete]="auto"
            [tabIndex]="2"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let customer of filteredCustomers | async"
              [value]="customer"
            >
              {{ customer }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="errorHandling('customerName', 'required')">
            Customer Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col" *ngIf="!hasPermission">
      <!-- spacer column -->
    </div>
  </div>
  <div>
    <digital-platform-address-input
      label="Site Address"
      formControlName="siteAddress"
      [required]="isRequired"
      [tabIndex]="4"
      [countyRequired]="isRequired"
      [isReadOnly]="generatorFieldsDisabled"
      (formValidityChanged)="onFormValidityChanged($event)"
      [isLegacy]="isLegacy"
    ></digital-platform-address-input>
  </div>

  <div class="column-2">
    <div class="col">
      <div class="input-container">
        <label
          >State ID/ Region NO
          <button
            mat-icon-button
            class="btn-hint"
            matTooltip="Applies only if State Agencies issue identification or registration numbers. (For instance, Illinois EPA has a ten-digit code assigned to each generator of special waste)."
          >
            <mat-icon>help</mat-icon>
          </button>
        </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            formControlName="regulatoryIdNumber"
            matInput
            [tabIndex]="11"
          />
          <mat-error *ngIf="errorHandling('regulatoryIdNumber', 'required')">
            State ID/ Region NO is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="content-align-left input-container">
        <mat-checkbox
          formControlName="regulatoryIdNumberNotApplicable"
          [tabIndex]="12"
        >
          Not Applicable (Only if state doesn't issue codes)
        </mat-checkbox>
      </div>
    </div>
    <div class="col">
      <div class="input-container">
        <label
          >NAICS # (optional)
          <button
            mat-icon-button
            class="btn-hint"
            matTooltip="Each industry class is assigned a code called a North American Industry Classification System. The classification is assigned to the process that generates a specific product"
          >
            <mat-icon>help</mat-icon>
          </button>
        </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            matInput
            placeholder="_ _ _ _ _ _ _"
            formControlName="naicsNumber"
            [tabIndex]="13"
          />
        </mat-form-field>
      </div>

      <div class="input-container">
        <label>EPA ID # (optional) </label>
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          [tabIndex]="14"
        >
          <input matInput formControlName="epaId" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="column-1">
    <div class="col">
      <div class="content-align-left input-container">
        <mat-checkbox
          formControlName="isMailingAddressSameAsSite"
          (change)="onSameAddressChange($event)"
          [tabIndex]="15"
        >
          Check if Same as Site Address
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div>
    <digital-platform-address-input
      label="Mailing Address"
      formControlName="generatorAddress"
      [required]="isRequired"
      [tabIndex]="16"
      [profileStatus]="profileStatus"
      [isLegacy]="isLegacy"
    ></digital-platform-address-input>
  </div>

  <div class="column-2" formGroupName="contact">
    <div class="col">
      <div class="input-container">
        <label>Generator Contact Name </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input formControlName="name" matInput [tabIndex]="22" />
          <mat-error *ngIf="errorHandlingContact('name', 'required')">
            Generator Contact Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>Phone Number </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            formControlName="phone"
            matInput
            digitalPlatformPhoneFormat
            placeholder="_ _ _ - _ _ _ - _ _ _ _"
            [tabIndex]="24"
          />
          <mat-error *ngIf="errorHandlingContact('phone', 'required')">
            Phone Number is <strong>Required</strong>
          </mat-error>
          <mat-error
            class="error"
            id="requestorContact.phone.pattern"
            *ngIf="errorHandlingContact('phone', 'pattern')"
          >
            Phone Number Format Must be a ___-___-____
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>Fax Number (optional)</label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input formControlName="fax" matInput [tabIndex]="26" />
        </mat-form-field>
      </div>
    </div>

    <div class="col">
      <div class="input-container">
        <label>Email </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input matInput formControlName="email" [tabIndex]="23" />
          <mat-error *ngIf="errorHandlingContact('email', 'required')">
            Email is <strong>Required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandlingContact('email', 'email')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>Phone Extension (optional) </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input matInput formControlName="phoneExt" [tabIndex]="25" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="column-1" *ngIf="displayMode === 'customer'">
    <div class="col">
      <div class="content-align-left input-container">
        <mat-checkbox formControlName="isOneTimeOnly" [tabIndex]="27">
          One Time Only Generator
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div
    class="col third-party-questions-component"
    *ngIf="displayMode === 'admin'"
  >
    <digital-platform-generator-third-party-questions
      formControlName="thirdPartyControl"
      [displayMode]="displayMode"
      [profileStatus]="profileStatus"
    >
    </digital-platform-generator-third-party-questions>
  </div>
</form>
